var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center C888"},[_c('p',{staticClass:"mt80 bold Con opacity5",staticStyle:{"font-size":"140px"}},[_vm._v("404")]),_vm._v(" 无此页面 ")])
}]

export { render, staticRenderFns }